import React, { useState, useMemo } from "react";

// Using array pattern for better destructuring in consumer components: [errors, setErrors]
export const WorkflowErrors = React.createContext([[], () => {}]);

export const WorkflowErrorsProvider = ({ children }) => {
  const [workflowErrors, setWorkflowErrors] = useState([]);

  const value = useMemo(
    () => [workflowErrors, setWorkflowErrors],
    [workflowErrors]
  );

  return (
    <WorkflowErrors.Provider value={value}>{children}</WorkflowErrors.Provider>
  );
};
